import { createReducer, on } from '@ngrx/store';
import { ManagedApplicationsApiActions } from './managed-applications.actions';
import { adapter, initialState } from './managed-applications.state';

export const mdmManagedAppliationsFeatureKey = 'mdm-managed-applications';

export const managedApplicationsReducer = createReducer(
  initialState,
  on(ManagedApplicationsApiActions.managedApplicationsLoaded, (state, { managedApplications }) => {
    return adapter.upsertMany(managedApplications, state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectManagedApplicationsIds = selectIds;

export const selectManagedApplicationsEntities = selectEntities;

export const selectAllManagedApplications = selectAll;
